export const CHECKOUT_URL = 'https://tenis-360.impultienda.ar/checkout'
